import { useState } from "react";
// @ts-ignore
import { MUIEditorState } from "react-mui-draft-wysiwyg";
import { useParams } from "react-router";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import { handleErrorMessage, richTextStateToHtml, useEffectOnce } from "../../../../utils/Utils";

interface NotesServiceType {
  article: any;
  openNoteDialog: boolean;
  openNoteDialogAction: any;
  closeNoteDialogAction: any;
  note: any;
  setNote: any;
  saveNote: any;
}

export default function NotesService(): NotesServiceType {
  const { axiosGetArticleById, axiosPostArticleAddNote }: ArticleControllerType = ArticleController();
  const { showMessage } = useAppContext();
  const [article, setArticle] = useState<any>([]);
  const [openNoteDialog, setNoteDialog] = useState<boolean>(false);
  const [note, setNote] = useState<string>(MUIEditorState.createEmpty());

  const { id }: any = useParams();

  useEffectOnce(() => {
    getArticleById();
  });

  const getArticleById = () => {
    axiosGetArticleById(id)
      .then((result: any) => {
        setArticle(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const openNoteDialogAction = () => {
    setNoteDialog(true);
  };

  const closeNoteDialogAction = () => {
    setNoteDialog(false);
    setNote(MUIEditorState.createEmpty());
  };

  const saveNote = () => {
    axiosPostArticleAddNote(id, richTextStateToHtml(note))
      .then((response: any) => {
        setArticle(response.data);
        closeNoteDialogAction();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    article,
    openNoteDialog,
    openNoteDialogAction,
    closeNoteDialogAction,
    note,
    setNote,
    saveNote,
  };
}

export type { NotesServiceType };
